// src/App.js
import React from 'react';
import InvoiceForm from './InvoiceForm';
import './App.css';

function App() {
  return (
    <div className="app-container">
      <h1>RCS INVOICE GENERATOR</h1>
      <InvoiceForm />
    </div>
  );
}

export default App;
